import React from 'react';

import SelectUILanguage from '@contactcentre-web/authentication/components/SelectUILanguage/SelectUILanguage';

const SelectUILanguagePage = () => <SelectUILanguage />;

export default SelectUILanguagePage;
